/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Users_CountInputs */

const en_admin_users_count = /** @type {(inputs: Admin_Users_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} users registered`)
};

const zh_admin_users_count = /** @type {(inputs: Admin_Users_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 个注册用户`)
};

/**
* | output |
* | --- |
* | "{count} users registered" |
*
* @param {Admin_Users_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_count = /** @type {((inputs: Admin_Users_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_count(inputs)
	return zh_admin_users_count(inputs)
});
export { admin_users_count as "admin.users.count" }